{
    "branch": "refs/heads/releases/tokyo-10-28-2026",
    "version": "1.0.4569"
}